export default __webpack_public_path__ + "static/media/05dd21a99279a0fbbbc0225585de41251576244258918.7c4328d3.webp";